import store from "@/store/store";
const gestionNetlinking = (list, filterObj) => {
	let thisList = JSON.parse(JSON.stringify(list));
	//console.log(999,thisList)
	if(thisList == undefined) thisList = [];
	else{
		for(let key in filterObj){
			if(filterObj[key] != "" && key !="filterType"){
				if(key == "society_id" || key == "landing_page" || key == "anchor_type" || key == "link_type" || key== "link_status" || key == "status"){
					let cloneThisList = [];
					thisList.forEach((element) => {
						//going through prestation
						if(key == "status"){
							element.missions = element.missions.filter((mission) => (filterObj["status"]).includes(mission.status));
							//only adding if mission satus is true to the condition
							if(element.missions.length > 0) cloneThisList.push(element);
						}
						else if(key == "society_id") element.society_id == filterObj[key] ? cloneThisList.push(element) : "";
						else{
							element.missions.forEach((mission) => {
								//going inside netlinks
								let containTable = [];
								if(key == "landing_page"){
									mission.netlinks = mission.netlinks.filter((netlink) => (netlink["landing_page"].toString().includes(filterObj[key].toString()) || netlink["url_bought"].toString().includes(filterObj[key].toString())));
								}
								else if(key == "link_status"){
									//because inisde netlinks they have property status and cannot be conflict with status which is in contract
									mission.netlinks = mission.netlinks.filter((netlink) => (filterObj[key]).includes(Number(netlink.status) + 1)); //adding plus 1 not conflict the default value
								}
								else if(key == "link_type"){
									mission.netlinks = mission.netlinks.filter((netlink) => netlink[key].toString() == (filterObj[key]).toString());
								}
								else{
									//direct filter without conditon
									mission.netlinks = mission.netlinks.filter((netlink) => netlink[key].toString() == (parseInt(filterObj[key])-1).toString());
								}
								if(mission.netlinks.length > 0){
									//if we get result from your criteria
									containTable = mission.netlinks;
								}
								if(containTable.length > 0){
									//adding element matching
									cloneThisList.push(element);
								}
							});
						}
					});
					let finalList =[];
					// checkiing netlinks is present or not and if not do not push
					cloneThisList.forEach((ele) => {
						finalList.push(ele);
					});
					//assignig final list to added element list for further process
					thisList = finalList;
				}
				else{
					//checking through the contract
					thisList = key == "type" ?
					//value is sent by adding one to avoid double selection with default value which is also 0
						thisList.filter(element => element[key] == filterObj[key] - 1) : thisList.filter(element => element[key] ? String(element[key]).includes(String(filterObj[key])) : element);
				}
			}
		}
	}
	return thisList;
};
export default {
	methods: {
		filterList: (type, list) => {
			let filteredList = [];
			let filterFields = store.state.filterFields;
			if(type === filterFields["filterType"]){
				switch(type){
				case"GESTION_NETLINKING_FILTER":
					filteredList = gestionNetlinking(list, filterFields);
					break;
				default:
					filteredList = list;
					break;
				}
			}
			else{
				filteredList = list;
			}
			return filteredList;
		},


	},

};

